import { MetadataItem } from '@/components/MetadataItem';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { HomeEvalAiResponse, HomeEvalResultV1 } from '@rock/types';
import type { FC } from 'react';

/** What the retired AI evaluation answered for one home. */
export const HomeEvalAiResponseDetails: FC<{ response: HomeEvalAiResponse }> = ({ response }) => (
    <div className="space-y-3">
        <MetadataItem
            label="Apply to Space/Home"
            value={
                <span className={response.applyToSpace ? 'text-green-600 font-semibold' : 'text-gray-600'}>
                    {response.applyToSpace ? 'Yes' : 'No'}
                </span>
            }
        />
        <MetadataItem
            label="Apply to Equipment"
            value={<span className="text-gray-700">{response.applyToEquipmentIds?.length ?? 0}</span>}
        />
        <MetadataItem label="Is Possible" value={<AiIsPossible possible={response.isPossible} />} />
        {response.issueMessage ? (
            <MetadataItem
                label="Issue Message"
                value={<div className="whitespace-pre-wrap text-base text-destructive">{response.issueMessage}</div>}
            />
        ) : null}
        <MetadataItem
            label="Summary"
            value={<div className="whitespace-pre-wrap text-base text-card-foreground">{response.summary}</div>}
        />
    </div>
);

export const AiIsPossible: FC<{ possible: boolean | null | undefined }> = ({ possible }) =>
    possible === false ? (
        <span className="text-red-600">No</span>
    ) : possible === true ? (
        <span className="text-green-600">Yes</span>
    ) : (
        <span className="text-gray-600">-</span>
    );

export const HomeEvalAiContextCard: FC<{ aiContext: HomeEvalResultV1['aiContext'] }> = ({ aiContext }) => (
    <Card>
        <CardHeader className="border-b-1 pb-3">
            <CardTitle className="text-xl">AI Context</CardTitle>
        </CardHeader>
        <CardContent>
            <div className="space-y-4">
                <div className="grid gap-4 md:grid-cols-2">
                    <MetadataItem label="Platform" value={aiContext.platform} />
                    <MetadataItem label="Model" value={aiContext.model} />
                </div>
                <div className="space-y-3">
                    <div className="flex flex-col gap-2">
                        <div className="text-sm text-muted-foreground">System Message</div>
                        <pre className="whitespace-pre-wrap text-xs bg-muted p-4 rounded-md overflow-x-auto">
                            {aiContext.systemMessage}
                        </pre>
                    </div>
                    <div className="flex flex-col gap-2">
                        <div className="text-sm text-muted-foreground">User Message</div>
                        <pre className="whitespace-pre-wrap text-xs bg-muted p-4 rounded-md overflow-x-auto">
                            {aiContext.userMessage}
                        </pre>
                    </div>
                </div>
            </div>
        </CardContent>
    </Card>
);
